import Link from 'next/link';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  resetNextUuid
} from 'react-accessible-accordion';

import { useAuth0User } from '@hooks/useAuth0User';
import Icon from '@components/atoms/icon';
import { isUserAuthenticated } from '@lib/utils';

const FFHAccordion = ({ closeSidebar, data, setSearchModalIsOpen }) => {
  const { user } = useAuth0User();

  const setCloseSidebar = () => {
    closeSidebar();
  };

  resetNextUuid();

  return (
    <Accordion allowZeroExpanded>
      {data.map((navItem) => {
        if (!isUserAuthenticated(user) && navItem.isHiddenForGuests) {
          return;
        }
        if (navItem.isTopLevel && !navItem.noChildLinks) {
          return (
            <AccordionItem key={navItem.level}>
              <AccordionItemHeading>
                <AccordionItemButton>{navItem.name}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {data
                  .filter((allItems) => !allItems.isTopLevel)
                  .map((navItemInner) => {
                    if (
                      navItemInner.level.split('.')[0] !==
                      navItem.level.split('.')[0]
                    ) {
                      return null;
                    }
                    if (!navItemInner.url) {
                      return (
                        <p
                          key={navItemInner.level}
                          className="px-4 pt-2 mt-3 rounded-t-lg uppercase text-xs font-bold text-open-sans text-white bg-[#2D3030]"
                        >
                          {navItemInner.name}
                        </p>
                      );
                    }
                    return (
                      <Link
                        key={navItemInner.level}
                        href={navItemInner.url}
                        onClick={() => setCloseSidebar()}
                        className="nav__link"
                        target={`${
                          navItemInner.isOpenInNewWindow ? '_blank' : '_self'
                        }`}
                      >
                        {navItemInner.name}
                        {navItemInner.isOpenInNewWindow && (
                          <Icon name="ExternalLink" className="ml-1 w-3 h-3" />
                        )}
                      </Link>
                    );
                  })}
              </AccordionItemPanel>
            </AccordionItem>
          );
        }
      })}
      <div className="flex justify-between items-center p-2 pb-4">
        <a
          className="text-white font-bold font-open-sans text-base inline-block w-full"
          target="_blank"
          rel="noopener noreferrer"
          href="https://onelink.to/ffhubapp"
          onClick={() => setCloseSidebar()}
        >
          App
        </a>
        <Icon className="text-white" name="ExternalLink" />
      </div>
      {!isUserAuthenticated(user) && (
        <div className="flex justify-between items-center p-2 pb-4 mb-3 border-b border-b-white">
          <Link
            href="/ai-team-rating"
            className="text-white font-bold font-open-sans text-base inline-block w-full"
            rel="noopener noreferrer"
            onClick={() => setCloseSidebar()}
          >
            AI Team Rating
          </Link>
        </div>
      )}
      <div
        onClick={() => {
          setSearchModalIsOpen(true);
          setCloseSidebar();
        }}
        className="flex items-center text-white p-2 pb-4 pl-1"
      >
        <Icon className="text-white w-4 h-4" name="Search"></Icon>
        <p className="text-base font-bold text-white ml-2">Search</p>
      </div>
      {isUserAuthenticated(user) && (
        <div className="flex items-center text-white p-2 pl-1 pb-4">
          <Icon className="text-white w-4 h-4" name="Person"></Icon>
          <Link
            href="/account"
            className="text-base font-bold text-white ml-2"
            onClick={() => setCloseSidebar()}
          >
            My Account
          </Link>
        </div>
      )}
    </Accordion>
  );
};

export default FFHAccordion;
